import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import AppLayout from '../Layouts/AppLayout/AppLayout';
import Home from '../Home/Home';
import Point from '../Point/Point';
import Results from '../Results/Results';
import Messages from '../Messages/Messages';
import BettingContainer from '../BettingContainer/BettingContainer';

function areEqual(prevProps, nextProps) {
    return prevProps !== nextProps;
}

const Main = () => {
    const match = useRouteMatch();
    return (
        <AppLayout>
            <Switch>
                <Redirect exact from={`${match.url}/`} to={`${match.path}/home`} />
                <Route path={`${match.url}/home`} component={Home} />
                <Route path={`${match.url}/point`} component={Point} />
                <Route path={`${match.url}/results`} component={Results} />
                <Route path={`${match.url}/messages`} component={Messages} />
                <BettingContainer match={match} />
            </Switch>
        </AppLayout>
    );
};

export default React.memo(Main, areEqual);
